import { useState } from "react";
import axios from "axios";
import { Pencil, Check, X } from "lucide-react";
import { toast } from "sonner";

// Tap-to-rename for a CTV platform; renames apply to the months in view and are remembered for future uploads
export const CtvPublisherName = ({ name, isOther, editable, API, clientId, reportStart, reportEnd, location, onRenamed, testId }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(name);
  const [saving, setSaving] = useState(false);
  const textClass = `font-medium text-xs truncate ${isOther ? "text-purple-300 italic" : "text-white"}`;

  if (!editable) return <span className={textClass}>{name}</span>;

  const save = async () => {
    const next = value.trim();
    if (!next || next === name) return setEditing(false);
    setSaving(true);
    try {
      await axios.post(`${API}/ctv-publishers/rename`, {
        client_id: clientId, old_name: name, new_name: next,
        report_start: reportStart || "", report_end: reportEnd || "", location_name: location && location !== "all" ? location : "",
      });
      toast.success(`Renamed to ${next}`);
      setEditing(false);
      onRenamed?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not rename this platform");
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="flex items-center gap-1 min-w-0 flex-1">
        <input
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
          className="min-w-0 flex-1 bg-slate-900/60 border border-purple-400/40 rounded px-1.5 py-0.5 text-xs text-white outline-none focus:border-purple-300"
          data-testid={`${testId}-input`}
        />
        <button type="button" onClick={save} disabled={saving} className="text-emerald-300 hover:text-emerald-200 disabled:opacity-50" data-testid={`${testId}-save`}>
          <Check className="w-3.5 h-3.5" />
        </button>
        <button type="button" onClick={() => { setValue(name); setEditing(false); }} className="text-slate-400 hover:text-white" data-testid={`${testId}-cancel`}>
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => { setValue(name); setEditing(true); }}
      className="group/rn flex items-center gap-1 min-w-0 text-left"
      title="Tap to rename this platform"
      data-testid={`${testId}-rename`}
    >
      <span className={textClass}>{name}</span>
      <Pencil className="w-3 h-3 text-purple-300/60 opacity-0 group-hover/rn:opacity-100 transition-opacity flex-shrink-0" />
    </button>
  );
};
